export default "__VITE_ASSET__BguK1Lt2__"